import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  trialWarning: {
    defaultMessage: 'Your free trial ends soon! Select a plan before <b>{trialEndDate}</b> to keep shipping.',
    description:
      'A message telling the user that their free trial is ending soon and that they should select a plan. The trial end date is in the format "Jan 1, 2024".',
    id: 'IyxihI',
  },
  trialExpired: {
    defaultMessage: 'Your free trial ended on <b>{trialEndDate}</b>. Select a plan to keep shipping.',
    description:
      'A message telling the user that their free trial has ended and that they should select a plan. The trial end date is in the format "Jan 1, 2024".',
    id: 'mp+KjP',
  },
  trialInfo: {
    defaultMessage: 'Your free trial ends in <b>{daysLeftInTrial, plural, one {# day} other {# days}}.</b>',
    description: 'A message telling the user how many days are left in their free trial.',
    id: 'SLQ3ps',
  },
  selectPlan: {
    defaultMessage: 'Select a Plan',
    description: 'Text for a button that opens a modal to change the subscription plan.',
    id: 'aUb8zx',
  },
  selectPlanBeforeDate: {
    defaultMessage: 'Select a plan before {trialEndDate} to keep shipping!',
    description:
      'Text for a button that opens a modal to change the subscription plan before their trial ends. The trial end date is in the format "Jan 1, 2024".',
    id: 'OoBl1I',
  },
  updateBillingInfo: {
    defaultMessage: 'Update',
    description: 'Button text telling the user to update their payment info',
    id: 'I2u8jb',
  },
  paymentDueMessage: {
    defaultMessage: 'Update your payment method to continue using ShipStation',
    description: 'Text for top banner telling the user that they need to update payment method or be terminated',
    id: 'hA6qU+',
  },
  content: {
    description: 'Content for the banner message explaining how to verify account',
    defaultMessage: 'We take your safety seriously, please check your email and follow the instructions to verify your account.',
    id: 'Y1k1H7',
  },
  resendEmail: {
    description: 'resend email verification button text',
    defaultMessage: 'Resend email verification.',
    id: 'ZTHCJy',
  },
  emailResentTitle: {
    description: 'resend email verification success notification title',
    defaultMessage: 'Verification Email resent successfully',
    id: '2t7y7A',
  },
  emailResentBody: {
    description: 'resend email verification success notification body',
    defaultMessage: 'Please check your email and follow the instructions to verify your account.',
    id: 'vHtTWp',
  },
  emailResentErrorTitle: {
    description: 'resend email verification error notification title',
    defaultMessage: 'Verification Email resend failed',
    id: '8rWRJJ',
  },
  emailResentErrorBody: {
    description: 'resend email verification error notification body',
    defaultMessage: 'Please try again or contact support.',
    id: 'Dwv3ce',
  },
  fraudWarning: {
    defaultMessage: 'Become a verified merchant to remove the ${limit} spending limit on label purchases. <button>Verify Now</button>',
    id: 'sNLB74',
    description: "Text for banner when user has not reached their spending limit and hasn't verified",
  },
  fraudError: {
    defaultMessage:
      '<b>You have reached your spending limit!</b> Become a verified merchant to remove the ${limit} spending limit. <button>Verify Now</button>',
    id: '/sy3vO',
    description: "Text for banner when user has reached their spending limit and hasn't verified",
  },
  addTaxId: {
    defaultMessage: 'Please add your valid Tax ID <a>Add your Tax ID</a>',
    description: 'Text for the add tax id banner with a link',
    id: 'f/b/n/',
  },
  phoneVerificationContent: {
    description: 'Phone verification banner message prompting user to verify phone',
    defaultMessage: 'Please take a moment to secure your account by verifying your phone number.',
    id: '3QgYwi',
  },
  phoneVerificationButton: {
    description: 'Button text to open phone verification settings',
    defaultMessage: 'Verify Phone',
    id: 'HrmL+R',
  },
  uspsNsaBannerContent: {
    description: 'Content for USPS NSA rates banner message',
    defaultMessage: 'Connect your USPS Business Account to Stamps.com to access NSA rates.',
    id: 'EOldJw',
  },
  uspsNsaBannerButton: {
    description: 'Button text for USPS NSA banner to see instructions',
    defaultMessage: 'See Instructions',
    id: 'fnbSQ+',
  },
  uspsNsaModalTitle: {
    description: 'Title for USPS NSA modal',
    defaultMessage: 'Connect Your USPS Business Account',
    id: 'eP8OvP',
  },
  uspsNsaModalDescription: {
    description: 'Description for USPS NSA modal explaining the connection process',
    defaultMessage:
      'To access special rates from your Negotiated Service Agreement (NSA), you need to connect your USPS Business Account with Stamps.com.',
    id: 'o5P6h9',
  },
  uspsNsaModalLearnMoreButton: {
    description: 'Button text to learn more about USPS NSA',
    defaultMessage: 'Learn More about NSA Rates',
    id: 'Veko3h',
  },
  uspsNsaModalCloseButton: {
    description: 'Button text to close the modal',
    defaultMessage: 'Close',
    id: 'tVz3SL',
  },
  uspsNsaPermissionTooltip: {
    description: 'Tooltip text when user does not have permission to access USPS settings',
    defaultMessage: 'You do not have the appropriate permissions to access USPS account settings.',
    id: '0syzOG',
  },
  uspsNsaWaitingForApprovalContent: {
    description: 'Content for USPS NSA waiting for approval banner message',
    defaultMessage: 'Please contact your USPS sales rep to ensure your EPA and contract are linked.',
    id: 'Pk9cyC',
  },
  trialUpgradeInfo: {
    defaultMessage:
      'Upgrade your plan within {daysLeftInTrial, plural, one {# day} other {# days}} to maintain access to {planTierName} features and ensure your shipping operations remain uninterrupted.',
    description: 'Banner message encouraging users to upgrade before trial ends to keep plan tier features',
    id: 'peyC2j',
  },
  trialExpiredContent: {
    defaultMessage:
      'Your free trial has expired, and you no longer have access to {planTierName} features. To continue using these features, please upgrade your plan.',
    description: 'Banner message when plan features trial has expired',
    id: 'PTTf1R',
  },
  upgradeYourPlan: {
    defaultMessage: 'Upgrade Your Plan',
    description: 'Button text to upgrade subscription plan',
    id: 'VJ3YF5',
  },
  phoneNumberCaptureBannerContent: {
    defaultMessage: 'Add your <a>phone number</a> to stay informed with alerts and get access to setup help.',
    description: 'Content for the phone number capture banner with a link to open the modal',
    id: 'h7cGTl',
  },
});
